import { useQuery } from '@tanstack/react-query';
import { NoteCard } from '@/reports/sections/NotesSection/Notes/NoteCard';
import { Notes, ReportNote } from '@/reports/sections/NotesSection/Notes/Notes';

interface ReportNoteListProps {
  permalink: string;
}

export function NoteList({ permalink }: ReportNoteListProps) {
  const { data, isError, isLoading } = useQuery<ReportNote[]>({
    queryKey: ['reportNotes'],
    queryFn: () => Notes.getNotes(permalink),
  });

  // TODO: Styling needed
  if (isLoading) {
    return <div>loading notes</div>;
  }

  // TODO: Styling needed
  if (isError) {
    return <div>Error loading notes please try again!</div>;
  }

  return (
    <>
      {data.map((note: ReportNote) => (
        <NoteCard key={note.id} note={note} />
      ))}
    </>
  );
}
